import validate from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.6_@types+node@25.5.0_@vue+compiler-sfc@3.5.30_better-sql_608ee6d43a618caaf934593ecbea3b89/node_modules/nuxt/dist/pages/runtime/validate.js";
import aa_45redirects_45global from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/middleware/aa-redirects.global.ts";
import admin_45global from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/middleware/admin.global.ts";
import auth_45global from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/middleware/auth.global.ts";
import manifest_45route_45rule from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.6_@types+node@25.5.0_@vue+compiler-sfc@3.5.30_better-sql_608ee6d43a618caaf934593ecbea3b89/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  aa_45redirects_45global,
  admin_45global,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}